import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class TopNavigationSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'topnavigation');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.comboField('style', {
                'Hidden': 'hidden',
                'Header': 'header',
                'Navigation': 'navigation',
            }),

            this.fontFamilyField('font.family', ['header', 'main', 'content', 'header']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['header', 'main', 'content', 'header']),
            this.backgroundColorField('background.color', ['header', 'main', 'content']),
            this.borderColorField('border.color', ['header', 'main', 'content']),
            this.sizeNumberField('border.width', 'px'),

            
            // active
            this.fontColorComboField('active.font.color', ['topnavigation', 'main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.background.color', ['topnavigation', 'tab', 'content'], this.preset('active-background-color', 'main')),
            this.fontColorComboField('active.tab.font.color', ['topnavigation', 'main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.tab.background.color', ['topnavigation', 'tab', 'content'], this.preset('active-background-color', 'main')),
            this.fontColorComboField('active.indicator.color', []),
            
            this.fontColorComboField('hover.font.color', ['topnavigation', 'main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['topnavigation', 'tab', 'content'], this.preset('hover-background-color', 'main')),
            this.fontColorComboField('hover.tab.font.color', ['topnavigation', 'main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.tab.background.color', ['topnavigation', 'tab', 'content'], this.preset('hover-background-color', 'main')),

            this.comboField('logo.style', {
                'None': 'none',
                'Left': 'left',
                'Right': 'right',
            }),


        ];
    }

}
